export class TieUp {
  id?: string;

  begin?: string;

  end?: string;

  store?: string;

  shipping?: string;

  akasatana?: string;

  enable?: string;

  constructor(init?: Partial<TieUp>) {
    Object.assign(this, init);
  }
}

